<template>
    <div>
        <ProgressBar :progress-value="progressValue" is-animated/>
        <BackButton />

        <p>Wir freuen uns, dass Sie sich für das MAS Weiterbildungsangebot der ZHAW interessieren.</p>

        <b-form @submit="onSubmit">
            <b-form-group class="zhaw-form-group">
                <label>In welchem Berufsfeld sind Sie aktuell tätig? *</label>
                <i class="zhaw-tooltip" v-b-tooltip.hover title="Platzhalter-Beschreibung: Berufsfeld">
                    <font-awesome-icon :icon="['fas', 'info-circle']"/>
                </i>
                <b-form-select :options="form.professionalFieldOptions" id="professional-field"
                               v-model="form.selectedProfessionalField" required>
                    <template v-if="!axiosHasError" v-slot:first>
                        <option :value="null" disabled>Bitte wählen Sie ein Berufsfeld...</option>
                    </template>
                    <template v-else v-slot:first>
                        <option :value="null" disabled>Fehler beim Laden der Daten</option>
                    </template>
                </b-form-select>
            </b-form-group>

            <b-form-group class="zhaw-form-group">
                <label>Wie lange sind Sie bereits in Ihrem Berufsumfeld tätig?  *</label>
                <i class="zhaw-tooltip" v-b-tooltip.hover :title="'Platzhalter-Beschreibung: Dauer der Tätigkeit im Berufsfeld ' + form.selectedProfessionalField">
                    <font-awesome-icon :icon="['fas', 'info-circle']"/>
                </i>
                <b-form-select :options="form.professionalExperienceOptions" id="professional-field-duration"
                               v-model="form.selectedProfessionalExperience" required>
                </b-form-select>
            </b-form-group>

            <b-form-group class="zhaw-form-group">
                <label>Möchten Sie sich in Ihrem aktuellen Berufsfeld weiterbilden? *</label>
                <i class="zhaw-tooltip" v-b-tooltip.hover title="Platzhalter-Beschreibung: Entscheidung ob Weiterbildung im aktuellen Berufsumfeld">
                    <font-awesome-icon :icon="['fas', 'info-circle']"/>
                </i>
                <b-form-radio-group v-model="form.selectedFurtherEducate" stacked required>
                    <b-form-radio :value="form.furtherEducateValues.yes" name="further-educate-in-job-profile">Ja</b-form-radio>
                    <b-form-radio :value="form.furtherEducateValues.no" name="further-educate-in-job-profile">Nein</b-form-radio>
                    <b-form-radio :value="form.furtherEducateValues.maybe" name="further-educate-in-job-profile">Weiss nicht</b-form-radio>
                </b-form-radio-group>
            </b-form-group>

            <b-form-group class="zhaw-form-group">
                <label>Was haben Sie für ein Geschlecht? *</label>
                <i class="zhaw-tooltip" v-b-tooltip.hover title="Platzhalter-Beschreibung: Geschlecht">
                    <font-awesome-icon :icon="['fas', 'info-circle']"/>
                </i>
                <b-form-radio-group v-model="form.selectedGender" stacked required >
                    <b-form-radio name="gender" value="Female">Weiblich</b-form-radio>
                    <b-form-radio name="gender" value="Male">Männlich</b-form-radio>
                    <b-form-radio name="gender" value="NoComment">Keine Angabe</b-form-radio>
                </b-form-radio-group>
            </b-form-group>

            <CancelButton router-link="/start" />
            <b-button type="submit" variant="primary">
                <font-awesome-icon :icon="['fas', 'chevron-right']" />
                Weiter
            </b-button>
        </b-form>
    </div>
</template>

<script>
    import {herokuApi, isUsingMockData, mockApi} from "../api/axiosConfig"
    import ProgressBar from "./helper-components/ProgressBar";
    import BackButton from "./helper-components/BackButton";
    import CancelButton from "./helper-components/CancelButton";
    import sharedStore from "../state-management/store"

    export default {
        name: "InitialForm",
        components: {CancelButton, BackButton, ProgressBar},
        data() {
            return {
                form: {
                    professionalFieldOptions: [], // Will be dynamically filled via API.
                    selectedProfessionalField: sharedStore.state.initialForm.selectedProfessionalField,
                    professionalExperienceOptions: [ // Values need to be matching with the data structure from the API.
                        {value: null, text: 'Bitte wählen Sie aus...'},
                        {value: -1, text: 'Keine Angabe'},
                        {value: 3, text: 'Bis 3 Jahre'},
                        {value: 7, text: 'Bis 7 Jahre'},
                        {value: 12, text: 'Bis 12 Jahre'},
                        {value: 99, text: 'Mehr als 12 Jahre'}
                    ],
                    selectedProfessionalExperience: sharedStore.state.initialForm.selectedProfessionalExperience,
                    furtherEducateValues: { // Values need to be matching with the data structure from the API.
                        yes: 1,
                        no: -1,
                        maybe: 0
                    },
                    selectedFurtherEducate: sharedStore.state.initialForm.selectedFurtherEducate,
                    selectedGender: sharedStore.state.initialForm.selectedGender
                },
                progressValue: sharedStore.state.progressValue,
                axiosHasError: false,
                axiosErrors: [],
                axiosLoading: true
            }
        },
        computed: {
            isFormIncomplete: function () { // Property needed to ensure form is filled (workaround because Bootstrap Vue validations does not work yet).
                return this.form.selectedProfessionalField === null
                    || this.form.selectedProfessionalExperience === null
                    || this.form.selectedFurtherEducate === null
                    || this.form.selectedGender === null
            }
        },
        methods: {
            async onSubmit(evt) {
                evt.preventDefault();
                sharedStore.increaseProgressValue(10);
                sharedStore.setInitialForm(this.form.selectedProfessionalField, this.form.selectedProfessionalExperience,
                    this.form.selectedFurtherEducate, this.form.selectedGender);

                await herokuApi
                    .post('/recommender/initSession', {
                        profession: this.form.selectedProfessionalField,
                        professionExperience: this.form.selectedProfessionalExperience,
                        professionRating: this.form.selectedFurtherEducate,
                        gender: this.form.selectedGender
                    })
                    .then(() => sharedStore.setIsInitSessionFinished(false))
                    .catch(error => {
                        this.axiosErrors.push(error);
                        this.axiosHasError = true
                    })
                    .finally(() => {
                        this.axiosLoading = false;
                        sharedStore.setIsInitSessionFinished(true)
                    });
                await this.$router.push("/interessen/1");
            },
            async loadProfessions() {
                if (!isUsingMockData){
                    await herokuApi
                        .get('/recommender/professions')
                        .then(response => (this.form.professionalFieldOptions = response.data))
                        .catch(error => {
                            this.axiosErrors.push(error);
                            this.axiosHasError = true
                        })
                        .finally(() => this.axiosLoading = false)
                } else {
                    await mockApi
                        .get('/professions.json')
                        .then(response => (this.form.professionalFieldOptions = response.data))
                        .catch(error => {
                            this.axiosErrors.push(error);
                            this.axiosHasError = true
                        })
                        .finally(() => this.axiosLoading = false)
                }
            }
        },
        mounted() {
            this.loadProfessions();
        }
    }
</script>

<style scoped>
    .zhaw-form-group {
        margin-top: 2rem;
    }
</style>